import { useState, useEffect, useRef } from "react";
import "./Gallery.css";

const Gallery = ({ data, render, cols }) => {
  const containerRef = useRef(null);

  const [itemWidth, setItemWidth] = useState(0);
  let [columns, setColumns] = useState(3);
  let [columnContents, setColumnContents] = useState([]);
  let [columnHeights, setColumnHeights] = useState([]);

  const handleResize = () => {
    const c = containerRef.current;
    if (!c) return;
    const width = c.getBoundingClientRect().width;

    if (cols) {
      columns = cols;
      setColumns(cols);
    } else if (width <= 768) {
      columns = 4;
      setColumns(4);
      setItemWidth("100%");
      return;
    } else if (width <= 1024) {
      columns = 5;
      setColumns(5);
    } else if (width <= 2048) {
      columns = 6;
      setColumns(6);
    }
    const gap = 30; // should be 2 * flex gap in css
    setItemWidth((width - gap * (columns - 1)) / columns);
    putDataInColumns();
  };

  function putDataInColumns() {
    // you cannot delete items and expect this to work well
    // for each item, add it to the column with the least height

    columnHeights = Array.from({ length: columns }, () => 0);
    columnContents = Array.from({ length: columns }, () => []);

    for (let d of data) {
      const index = columnHeights.indexOf(Math.min(...columnHeights));
      columnHeights[index] += d.height;

      columnContents[index] = columnContents[index] || [];
      columnContents[index].push(d);

      console.log(columnHeights);
    }
    setColumnHeights(columnHeights);
    setColumnContents(columnContents);
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  useEffect(() => {
    putDataInColumns();
  }, [data]);

  return (
    <div
      key={data.length}
      ref={containerRef}
      className="gallery-container"
      style={{
        overflowY: "scroll",
      }}
    >
      <div className="gallery-grid">
        {columnContents.map((column, index) => (
          <div key={index} className="gallery-column">
            {column.map((item) => (
              <div key={item.id} className="gallery-item">
                {render(item, itemWidth)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
